import { WithChildren } from '../../../core/types/with-children.js';
import { XYChartColorScalesContext } from '../context/XYChartColorScales.context.js';
import { useRectData } from '../hooks/useRectData.js';
import { generateRectColorScaleBySeriesId } from '../utils/generate-rect-color-scale-by-series-id.js';

//TODO consider renaming this specific to the rect
export const XYChartColorScalesProvider = ({ children }: WithChildren) => {
  const { seriesIdToValueScaleDomain, seriesToMetadata, seriesWithDatapoints } =
    useRectData();

  const scalesMap = generateRectColorScaleBySeriesId(
    seriesWithDatapoints,
    seriesToMetadata,
    seriesIdToValueScaleDomain,
  );

  return (
    <XYChartColorScalesContext.Provider value={scalesMap}>
      {children}
    </XYChartColorScalesContext.Provider>
  );
};

XYChartColorScalesProvider['displayName'] = 'XYChartColorScaleProvider';
